import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-ui-progress-indicator',
    templateUrl: './ui-progress-indicator.component.html',
    styleUrls: ['./ui-progress-indicator.component.scss']
})
export class UiProgressIndicatorComponent implements OnInit {
    @Input() height: number;

    constructor() {
    }

    ngOnInit() {
    }

}
